import React, { useState } from 'react';
import { mockSubmissions } from '../data/mockData';
import { StatusBadge } from '../components/StatusBadge';
import { FileText, Check, X, Eye, MessageSquare, ChevronDown, ChevronUp } from 'lucide-react';
export const ValidationScreen: React.FC = () => {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  const [remarks, setRemarks] = useState('');
  const pendingSubmissions = mockSubmissions.filter(s => s.status === 'pending_validation');
  const toggleExpand = (id: string) => {
    setExpandedId(expandedId === id ? null : id);
    setRemarks('');
  };
  return <div className="max-w-6xl mx-auto" data-id="element-1658">
      <div className="mb-6" data-id="element-1659">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-1660">ডেটা যাচাইকরণ</h1>
        <p className="text-slate-500" data-id="element-1661">
          দাখিলকৃত খতিয়ান ডেটা এবং নথিপত্র পর্যালোচনা ও যাচাই করুন
        </p>
      </div>

      <div className="card" data-id="element-1662">
        <div className="p-4 border-b border-slate-200 bg-slate-50 flex justify-between items-center" data-id="element-1663">
          <h2 className="font-semibold text-slate-800" data-id="element-1664">
            অপেক্ষমাণ দাখিলসমূহ ({pendingSubmissions.length})
          </h2>
          <div className="flex space-x-2" data-id="element-1665">
            <input type="text" placeholder="মৌজা খুঁজুন..." className="input-field py-1 text-sm w-48" data-id="element-1666" />
          </div>
        </div>

        <div className="divide-y divide-slate-200" data-id="element-1667">
          {pendingSubmissions.map(sub => <div key={sub.id} className="bg-white" data-id="element-1668">
              {/* Row Header */}
              <div className="p-4 flex items-center justify-between cursor-pointer hover:bg-slate-50 transition-colors" onClick={() => toggleExpand(sub.id)} data-id="element-1669">
                <div className="flex items-center space-x-6" data-id="element-1670">
                  <div data-id="element-1671">
                    <p className="text-xs text-slate-500 font-medium" data-id="element-1672">আইডি</p>
                    <p className="text-sm font-semibold text-slate-900" data-id="element-1673">
                      {sub.id}
                    </p>
                  </div>
                  <div data-id="element-1674">
                    <p className="text-xs text-slate-500 font-medium" data-id="element-1675">
                      অবস্থান
                    </p>
                    <p className="text-sm text-slate-800" data-id="element-1676">
                      {sub.mouja}, {sub.upazila}
                    </p>
                  </div>
                  <div data-id="element-1677">
                    <p className="text-xs text-slate-500 font-medium" data-id="element-1678">
                      খতিয়ান সংখ্যা
                    </p>
                    <p className="text-sm text-slate-800" data-id="element-1679">{sub.khatianCount}</p>
                  </div>
                  <div data-id="element-1680">
                    <p className="text-xs text-slate-500 font-medium" data-id="element-1681">
                      দাখিলকারী
                    </p>
                    <p className="text-sm text-slate-800" data-id="element-1682">{sub.submittedBy}</p>
                  </div>
                  <div data-id="element-1683">
                    <p className="text-xs text-slate-500 font-medium" data-id="element-1684">
                      ফরম্যাট
                    </p>
                    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${sub.isUnicode ? 'bg-purple-100 text-purple-800' : 'bg-orange-100 text-orange-800'}`} data-id="element-1685">
                      {sub.isUnicode ? 'ইউনিকোড' : 'নন-ইউনিকোড'}
                    </span>
                  </div>
                </div>
                <div className="flex items-center space-x-4" data-id="element-1686">
                  <StatusBadge status={sub.status} data-id="element-1687" />
                  {expandedId === sub.id ? <ChevronUp size={20} className="text-slate-400" data-id="element-1688" /> : <ChevronDown size={20} className="text-slate-400" data-id="element-1689" />}
                </div>
              </div>

              {/* Expanded Details */}
              {expandedId === sub.id && <div className="p-6 bg-slate-50 border-t border-slate-100" data-id="element-1690">
                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1691">
                    {/* Documents Panel */}
                    <div className="col-span-2" data-id="element-1692">
                      <h3 className="text-sm font-semibold text-slate-800 mb-3 uppercase tracking-wider" data-id="element-1693">
                        দাখিলকৃত নথিপত্র
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1694">
                        <div className="bg-white p-4 rounded-md border border-slate-200 shadow-sm flex flex-col items-center text-center" data-id="element-1695">
                          <FileText size={32} className="text-blue-500 mb-2" data-id="element-1696" />
                          <span className="text-sm font-medium text-slate-800 mb-1" data-id="element-1697">
                            খতিয়ান ডেটা
                          </span>
                          <span className="text-xs text-slate-500 mb-3" data-id="element-1698">
                            {sub.files.khatianData}
                          </span>
                          <button className="text-xs text-blue-600 font-medium hover:underline flex items-center" data-id="element-1699">
                            <Eye size={14} className="mr-1" data-id="element-1700" /> ডেটা প্রিভিউ
                          </button>
                        </div>
                        <div className="bg-white p-4 rounded-md border border-slate-200 shadow-sm flex flex-col items-center text-center" data-id="element-1701">
                          <FileText size={32} className="text-red-500 mb-2" data-id="element-1702" />
                          <span className="text-sm font-medium text-slate-800 mb-1" data-id="element-1703">
                            গেজেট কপি/কেস কপি
                          </span>
                          <span className="text-xs text-slate-500 mb-3" data-id="element-1704">
                            {sub.files.gadgetCopy}
                          </span>
                          <button className="text-xs text-blue-600 font-medium hover:underline flex items-center" data-id="element-1705">
                            <Eye size={14} className="mr-1" data-id="element-1706" /> পিডিএফ দেখুন
                          </button>
                        </div>
                        <div className="bg-white p-4 rounded-md border border-slate-200 shadow-sm flex flex-col items-center text-center" data-id="element-1707">
                          <FileText size={32} className="text-red-500 mb-2" data-id="element-1708" />
                          <span className="text-sm font-medium text-slate-800 mb-1" data-id="element-1709">
                            হস্তান্তর পত্র/সংশোধন পত্র
                          </span>
                          <span className="text-xs text-slate-500 mb-3" data-id="element-1710">
                            {sub.files.handoverLetter}
                          </span>
                          <button className="text-xs text-blue-600 font-medium hover:underline flex items-center" data-id="element-1711">
                            <Eye size={14} className="mr-1" data-id="element-1712" /> পিডিএফ দেখুন
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Action Panel */}
                    <div data-id="element-1713">
                      <h3 className="text-sm font-semibold text-slate-800 mb-3 uppercase tracking-wider" data-id="element-1714">
                        যাচাইকরণ পদক্ষেপ
                      </h3>
                      <div className="bg-white p-4 rounded-md border border-slate-200 shadow-sm" data-id="element-1715">
                        <div className="space-y-3 mb-4" data-id="element-1716">
                          <label className="flex items-center space-x-2 text-sm text-slate-700" data-id="element-1717">
                            <input type="checkbox" className="rounded text-teal-600 focus:ring-teal-500" data-id="element-1718" />
                            <span data-id="element-1719">গেজেট কপি ডেটার সাথে মিলেছে</span>
                          </label>
                          <label className="flex items-center space-x-2 text-sm text-slate-700" data-id="element-1720">
                            <input type="checkbox" className="rounded text-teal-600 focus:ring-teal-500" data-id="element-1721" />
                            <span data-id="element-1722">হস্তান্তর পত্রে স্বাক্ষর রয়েছে</span>
                          </label>
                          <label className="flex items-center space-x-2 text-sm text-slate-700" data-id="element-1723">
                            <input type="checkbox" className="rounded text-teal-600 focus:ring-teal-500" data-id="element-1724" />
                            <span data-id="element-1725">মৌজা এবং জেএল নম্বর যাচাই করা হয়েছে</span>
                          </label>
                        </div>

                        <div className="mb-4" data-id="element-1726">
                          <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1727">
                            মন্তব্য (ফেরত পাঠানোর জন্য আবশ্যক)
                          </label>
                          <textarea className="input-field text-sm" rows={3} placeholder="মন্তব্য লিখুন..." value={remarks} onChange={e => setRemarks(e.target.value)} data-id="element-1728"></textarea>
                        </div>

                        <div className="flex space-x-3" data-id="element-1729">
                          <button className="flex-1 btn-danger py-2 text-sm flex items-center justify-center" data-id="element-1730">
                            <X size={16} className="mr-1" data-id="element-1731" /> ফেরত পাঠান
                          </button>
                          <button className="flex-1 btn-success py-2 text-sm flex items-center justify-center" data-id="element-1732">
                            <Check size={16} className="mr-1" data-id="element-1733" /> অনুমোদন করুন
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>)}
          {pendingSubmissions.length === 0 && <div className="p-8 text-center text-slate-500" data-id="element-1734">
              <Check size={48} className="mx-auto text-slate-300 mb-3" data-id="element-1735" />
              <p data-id="element-1736">যাচাই করার জন্য কোন অপেক্ষমাণ দাখিল নেই।</p>
            </div>}
        </div>
      </div>
    </div>;
};